import { cn } from "@/lib/utils";

/**
 * The one icon style for the home page (owner, 2 Nov 2026: "replace tacky icons").
 * A lucide icon in brand pink, stroke 2, 24px, on a 48px soft-pink tile.
 * tone="dark" is the same badge for black sections (How it works).
 * Decorative: the text next to it carries the meaning, so it is aria-hidden.
 */
export function IconBadge({ icon: Icon, tone = "light", className }) {
  return (
    <span
      aria-hidden="true"
      data-icon-badge={tone}
      className={cn(
        "inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ring-1 ring-inset",
        tone === "dark"
          ? "bg-brand-pink/15 ring-brand-pink/30"
          : "bg-[#FDF2F8] ring-brand-pink/15",
        className,
      )}
    >
      <Icon className="h-6 w-6 text-brand-pink" strokeWidth={2} />
    </span>
  );
}

export default IconBadge;
